import { createContext } from 'react';

import type { PortalProps } from '@frontend/legacy-components';

export type SelectContextValue = {
  portalContainerRef: PortalProps['containerRef'];
  hasSuggestions: boolean;
  hasAcceptedSuggestions: boolean;
  hasRejectedSuggestions: boolean;
  isPopoverOverlayEnabled: boolean;
};

export const SelectContext = createContext<SelectContextValue>({
  portalContainerRef: undefined,
  hasSuggestions: false,
  hasAcceptedSuggestions: false,
  hasRejectedSuggestions: false,
  isPopoverOverlayEnabled: false,
});

export const SelectContextProvider = SelectContext.Provider;
